var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ce-checkboxFilter",class:{'disabled': _vm.disabled}},[_c('checkbox',{attrs:{"disabled":!!_vm.disabled,"id":`key-${_vm.filterKey}`,"value":_vm.value},on:{"input":_vm.toggle}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }